const c = process.env.DEBUG ? console.log : () => { };
export default c;